import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _descriptor, _descriptor2, _descriptor3;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import decodeJwt from 'jwt-decode';
import { Store } from 'libx';
import { action, observable, reaction, runInAction, computed } from 'mobx';
import QS from 'qs';
import isNil from 'lodash/isNil';
import { interval, merge, Subject, Subscription, timer } from 'rxjs';
import { distinctUntilChanged, filter, first, map, mapTo, startWith, switchMap, exhaustMap } from 'rxjs/operators';
import env from '../misc/env';
import { PageActivity, pageActivityStream } from '../utils/domUtil';
import { filterNonNil, shareLatest } from '../utils/rxUtil';
import { format } from '../utils/translate';
import { getFeatureToggleClient } from '../misc/featureToggles';
import Auth0Client from '../misc/Auth0Client';
var origin = window.location.origin;
var AuthStore = (_dec = action.bound, _class = /*#__PURE__*/function (_Store) {
  function AuthStore(_ref) {
    var _this;
    var rootStore = _ref.rootStore,
      storage = _ref.storage,
      customProvider = _ref.customProvider;
    _classCallCheck(this, AuthStore);
    _this = _callSuper(this, AuthStore, arguments);
    _initializerDefineProperty(_this, "user", _descriptor, _this);
    _initializerDefineProperty(_this, "loggedIn", _descriptor2, _this);
    _initializerDefineProperty(_this, "referrer", _descriptor3, _this);
    _this.token = null;
    /**
     * @type {Auth0Client}
     */
    _this.auth0 = null;
    _this.referrerParams = {};
    /**
     * The token subject which emits when user authenticates or new token is refreshed.
     */
    _this.sessionSubject = new Subject();
    /**
     * Subscription for disposing.
     */
    _this.subscription = new Subscription();
    /**
     * Emits a refreshed session or `null` if we got logged out.
     *
     * @private
     */
    _this.sessionRefresh$ = _this.sessionSubject.pipe(first(function (v) {
      return v !== null;
    }), switchMap(function () {
      return merge(_this.pageActivity$.pipe(filter(function (a) {
        return a === PageActivity.Active;
      })), interval(10000)).pipe(exhaustMap(function () {
        return _this.fetchSessionInfo().catch(function (err) {
          console.error('Failed to refresh session in the background:', err);
          return null;
        });
      }));
    }), shareLatest());
    /**
     * Session stream.
     */
    _this.session$ = merge(_this.sessionSubject, _this.sessionRefresh$).pipe(
    // We only care about changes.
    distinctUntilChanged(function (a, b) {
      return (a === null || a === void 0 ? void 0 : a.token) === (b === null || b === void 0 ? void 0 : b.token);
    }),
    // Remember the last value for late subscribers.
    shareLatest());
    /**
     * Emits when we log out.
     * @private
     */
    _this.logout$ = _this.sessionRefresh$.pipe(first(function (s) {
      return s === null;
    }));
    /**
     * Emits when we log in elsewhere (another tab).
     * @private
     */
    _this.loggedInElsewhere$ = _this.session$.pipe(first(function (v) {
      return v === null;
    }), switchMap(function () {
      return _this.pageActivity$.pipe(filter(function (a) {
        return a === PageActivity.Active;
      }), switchMap(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", _this.fetchSessionInfo().catch(function (err) {
                logAuthError(err);
                return null;
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))), filterNonNil());
    }));
    /**
     * The token.
     */
    _this.token$ = _this.session$.pipe(filter(function (info) {
      var _decodeJwt;
      return info !== null && info !== void 0 && info.token ? ((_decodeJwt = decodeJwt(info === null || info === void 0 ? void 0 : info.token)) === null || _decodeJwt === void 0 ? void 0 : _decodeJwt.exp) * 1000 > Date.now() : false;
    }), map(function (s) {
      return s === null || s === void 0 ? void 0 : s.token;
    }), filterNonNil(), distinctUntilChanged());
    /**
     * Everytime we get a new token we start a new timer (old one gets killed by switch map).
     * The timer fires right away to say that the token is not stale anymore.
     * The timer fires 10 seconds before the token expires and emits an event which says dont use this token anymore.
     *
     * In theory this should not happen bc 60 seconds before expiration we should be getting a new token.
     */
    _this.stale$ = _this.token$.pipe(switchMap(function (token) {
      // The timer emits once 10 seconds before the exact expiration.
      var claims = decodeJwt(token);
      var date = new Date(claims.exp * 1000 - 10 * 1000);
      return timer(date).pipe(
      // When it emits, the token is stale (close to expiration), so emit `true`.
      mapTo(true),
      // Immediately on subscribe, emit `false`.
      startWith(false));
    }), shareLatest());
    _this.dispose = function () {
      return _this.subscription.unsubscribe();
    };
    _this.customProvider = customProvider;
    _this.getToken = _this.getToken.bind(_this);
    _this.rootStore = rootStore;
    _this.testTokenStorage = storage;
    _this.pageActivity$ = pageActivityStream();
    _this.auth0 = new Auth0Client({
      domain: env.AUTH0_DOMAIN,
      clientId: env.AUTH0_CLIENT_ID,
      audience: env.AUTH0_AUDIENCE_URL,
      redirectUri: origin
    });
    _this.subscription.add(_this.loggedInElsewhere$.subscribe(function () {
      window.location.reload();
    }));
    _this.subscription.add(_this.logout$.subscribe(function () {
      var _this$rootStore$sessi, _this$rootStore$sessi2, _this$rootStore$sessi3, _this$rootStore$sessi4;
      var logoutUrl = ((_this$rootStore$sessi = _this.rootStore.sessionStore.workspace) === null || _this$rootStore$sessi === void 0 ? void 0 : (_this$rootStore$sessi2 = _this$rootStore$sessi.config) === null || _this$rootStore$sessi2 === void 0 ? void 0 : (_this$rootStore$sessi3 = _this$rootStore$sessi2.signup) === null || _this$rootStore$sessi3 === void 0 ? void 0 : (_this$rootStore$sessi4 = _this$rootStore$sessi3.logout_url) === null || _this$rootStore$sessi4 === void 0 ? void 0 : _this$rootStore$sessi4.length) > 0 ? _this.rootStore.sessionStore.workspace.config.signup.logout_url : null;
      _this.logout(logoutUrl);
    }));
    return _this;
  }
  _inherits(AuthStore, _Store);
  return _createClass(AuthStore, [{
    key: "useCustomProvider",
    get: function get() {
      return !isNil(this.customProvider);
    }
  }, {
    key: "getToken",
    value:
    /**
     * Getter for the token.
     */
    function getToken() {
      return this.token;
    }
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(initialScreen, opts) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this._showDialogAndAuthorize(initialScreen, opts));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function login(_x, _x2) {
        return _login.apply(this, arguments);
      }
      return login;
    }()
  }, {
    key: "_showDialogAndAuthorize",
    value: function () {
      var _showDialogAndAuthorize2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(initialScreen, opts) {
        var workspace, connectionObj, passwordlessConnection;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!opts) {
                opts = {};
              }
              if (window && window.__workspaceDomain && window.__workspaceDomain.workspace) {
                workspace = window.__workspaceDomain.workspace;
                opts.logo = workspace.branding && workspace.branding.logos && workspace.branding.logos.icon;
                opts.color = workspace.branding && workspace.branding.colors && workspace.branding.colors.primary;
                if (workspace.config.signup && workspace.config.signup.connections) {
                  connectionObj = workspace.config.signup.connections;
                  passwordlessConnection = connectionObj.find(function (c) {
                    return c.type === 'passwordless';
                  });
                  opts.passwordless = passwordlessConnection && passwordlessConnection.enabled || false;
                  opts.connections = connectionObj.map(function (x) {
                    if (x.type === 'passwordless' || x.enabled === false) {
                      return null;
                    }
                    return x.type;
                  }).filter(Boolean);
                }
                if (workspace.config.signup) {
                  opts.title = workspace.config.signup.title;
                  opts.description = workspace.config.signup.description;
                }
                if (workspace.config.signup && workspace.config.signup.rules) {
                  opts.allow_signup = !hasInviteOnlyOption(workspace.config.signup.rules || []);
                }
              }
              opts.referrer = document.location.href;
              this.auth0.logout({
                localOnly: true
              });

              // ensure we clear the custom provider because we want to use Auth0 authentication
              this.customProvider = null;
              return _context3.abrupt("return", this.auth0.loginWithRedirect(_objectSpread(_objectSpread({}, opts), {}, {
                appState: {
                  customReferrerParams: this.referrerParams
                },
                initial_screen: initialScreen || 'login'
              })));
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function _showDialogAndAuthorize(_x3, _x4) {
        return _showDialogAndAuthorize2.apply(this, arguments);
      }
      return _showDialogAndAuthorize;
    }()
  }, {
    key: "setReferrerMeta",
    value: function setReferrerMeta(data) {
      this.referrerParams = data;
    }
  }, {
    key: "isEnterpriseUser",
    value: function isEnterpriseUser() {
      var _this$user, _this$user$authId;
      return (_this$user = this.user) === null || _this$user === void 0 ? void 0 : (_this$user$authId = _this$user.authId) === null || _this$user$authId === void 0 ? void 0 : _this$user$authId.toLowerCase().startsWith('samlp|');
    }
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(redirectUrl) {
        var _this$rootStore$sessi5, _this$rootStore$sessi6;
        var _this$user2;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              // lets allow message formatting on logout redirectUrls
              // and just pass a bunch of obj in there
              if (redirectUrl) {
                redirectUrl = format(redirectUrl, {
                  user_id: (_this$user2 = this.user) === null || _this$user2 === void 0 ? void 0 : _this$user2.userId
                  // add as necessary
                });
              }
              if (this.useCustomProvider) {
                this.customProvider.logout();
              }
              _context4.next = 4;
              return this.rootStore.userStore.api.users.logout();
            case 4:
              this.auth0.logout({
                returnTo: origin + (redirectUrl ? "?redirect_to=".concat(encodeURIComponent(redirectUrl)) : ''),
                federated: this.isEnterpriseUser() && ((_this$rootStore$sessi5 = this.rootStore.sessionStore.workspace) === null || _this$rootStore$sessi5 === void 0 ? void 0 : (_this$rootStore$sessi6 = _this$rootStore$sessi5.config.signup) === null || _this$rootStore$sessi6 === void 0 ? void 0 : _this$rootStore$sessi6.federated_logout)
              });
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function logout(_x5) {
        return _logout.apply(this, arguments);
      }
      return logout;
    }()
  }, {
    key: "_setUser",
    value: function _setUser(attributes) {
      if (this.user) {
        this.user.set(attributes, {
          parse: true,
          stripUndefined: true
        });
      } else {
        this.user = this.rootStore.userStore.users.set(attributes);
      }
    }
  }, {
    key: "initUser",
    value: function () {
      var _initUser = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(session) {
        var trackingStore, _session$claims, impersonator, mfaEnrolled, authUser, userData;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(!session || this.user)) {
                _context5.next = 2;
                break;
              }
              return _context5.abrupt("return");
            case 2:
              trackingStore = this.rootStore.trackingStore;
              _session$claims = session.claims, impersonator = _session$claims['https://taxfyle.com/impersonator'], mfaEnrolled = _session$claims['https://worklayer.com/claims.mfa_enrolled'];
              _context5.next = 6;
              return this.rootStore.userStore.authenticate();
            case 6:
              authUser = _context5.sent;
              _context5.next = 9;
              return this.rootStore.userStore.fetchByPublicId(authUser.public_id);
            case 9:
              this._setUser({
                impersonator: impersonator,
                user_id: authUser.user_id
              });
              if (mfaEnrolled) {
                this.user.markMultiFactorAuthEnabled();
              }
              trackingStore && trackingStore.identify(this.user.userId, {
                first_name: this.user.given_name,
                last_name: this.user.family_name,
                email: this.user.email,
                login_count: this.user.logins_count,
                public_id: this.user.public_id,
                phone: this.user.phone
              });
              _context5.next = 14;
              return this.rootStore.userDataStore.getByPublicId(this.user.public_id);
            case 14:
              userData = _context5.sent;
              if (!this.user.email.includes('e2e-')) {
                getFeatureToggleClient().identify({
                  key: this.user.public_id,
                  email: this.user.email,
                  custom: {
                    workspace_slugs: userData.workspaceSlugs.slice()
                  }
                });
              }
            case 16:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function initUser(_x6) {
        return _initUser.apply(this, arguments);
      }
      return initUser;
    }()
  }, {
    key: "onLogout",
    value: function onLogout(fn) {
      var _this2 = this;
      reaction(function () {
        return _this2.loggedIn;
      }, function (loggedIn) {
        if (!loggedIn) {
          fn();
        }
      });
      return this;
    }
  }, {
    key: "onLogin",
    value: function onLogin(fn) {
      var _this3 = this;
      if (this.user && this.token) {
        fn();
      }
      reaction(function () {
        return _this3.user && _this3.token;
      }, function (user) {
        if (user && _this3.token) {
          fn();
        }
      });
      return this;
    }

    /**
     * Called by the router to check if we are still authenticated.
     */
  }, {
    key: "checkAuthentication",
    value: (function () {
      var _checkAuthentication = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var session, _err$response, _err$response$data, _err$response$data$me, _err$response2, _err$response2$data, _err$response2$data$m;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.handleRedirect();
            case 2:
              _context6.prev = 2;
              _context6.next = 5;
              return this.fetchSessionInfo();
            case 5:
              session = _context6.sent;
              _context6.next = 8;
              return this.initUser(session);
            case 8:
              this.sessionSubject.next(session);
              return _context6.abrupt("return", true);
            case 12:
              _context6.prev = 12;
              _context6.t0 = _context6["catch"](2);
              logAuthError(_context6.t0);
              this.sessionSubject.next(null);

              // Save the current URL to local storage so we can redirect after login.
              this.saveCurrentURLToStorage();
              if (_context6.t0 !== null && _context6.t0 !== void 0 && (_err$response = _context6.t0.response) !== null && _err$response !== void 0 && (_err$response$data = _err$response.data) !== null && _err$response$data !== void 0 && (_err$response$data$me = _err$response$data.message) !== null && _err$response$data$me !== void 0 && _err$response$data$me.includes('already in use') || _context6.t0 !== null && _context6.t0 !== void 0 && (_err$response2 = _context6.t0.response) !== null && _err$response2 !== void 0 && (_err$response2$data = _err$response2.data) !== null && _err$response2$data !== void 0 && (_err$response2$data$m = _err$response2$data.message) !== null && _err$response2$data$m !== void 0 && _err$response2$data$m.includes('you previously signed in with')) {
                this.rootStore.flashMessageStore.create({
                  type: 'error',
                  message: _context6.t0.response.data.message
                });
              }
              return _context6.abrupt("return", false);
            case 19:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[2, 12]]);
      }));
      function checkAuthentication() {
        return _checkAuthentication.apply(this, arguments);
      }
      return checkAuthentication;
    }())
  }, {
    key: "handleRedirect",
    value: function () {
      var _handleRedirect = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!this.customProvider) {
                _context7.next = 5;
                break;
              }
              _context7.next = 3;
              return this.handleRedirectWithCustomProvider();
            case 3:
              _context7.next = 7;
              break;
            case 5:
              _context7.next = 7;
              return this.handleRedirectWithAuth0();
            case 7:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function handleRedirect() {
        return _handleRedirect.apply(this, arguments);
      }
      return handleRedirect;
    }()
  }, {
    key: "fetchSessionInfo",
    value: function () {
      var _fetchSessionInfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", this.useCustomProvider ? this.fetchSessionInfoUsingCustomProvider() : this.fetchSessionInfoWithAuth0());
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function fetchSessionInfo() {
        return _fetchSessionInfo.apply(this, arguments);
      }
      return fetchSessionInfo;
    }()
  }, {
    key: "handleRedirectWithAuth0",
    value: function () {
      var _handleRedirectWithAuth = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var isRoot, _QS$parse, code, state, returnUrl;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              // If there is a code + state in the URL then attempt to exchange
              // it for a new token
              isRoot = window.location.pathname === '/';
              _QS$parse = QS.parse(window.location.search, {
                ignoreQueryPrefix: true
              }), code = _QS$parse.code, state = _QS$parse.state;
              if (!(isRoot && code && state)) {
                _context9.next = 20;
                break;
              }
              // Temporary Firefox workaround
              // https://github.com/auth0/auth0-spa-js/blob/master/FAQ.md#why-do-i-get-error-invalid-state-in-firefox-when-refreshing-the-page-immediately-after-a-login
              window.location.hash = window.location.hash; // eslint-disable-line no-self-assign
              _context9.prev = 4;
              _context9.next = 7;
              return this.auth0.handleRedirect(code, state);
            case 7:
              // It was a login redirect, restore the url
              returnUrl = window.localStorage.getItem('returnUrl');
              window.localStorage.removeItem('returnUrl');
              if (!returnUrl) {
                _context9.next = 12;
                break;
              }
              window.location.replace(returnUrl);
              return _context9.abrupt("return");
            case 12:
              _context9.next = 17;
              break;
            case 14:
              _context9.prev = 14;
              _context9.t0 = _context9["catch"](4);
              console.error('Code exchange failed:', _context9.t0);
            case 17:
              _context9.prev = 17;
              // Remove query string from URL to remove ?code=...&state=...
              window.history.replaceState(null, '', window.location.pathname);
              return _context9.finish(17);
            case 20:
              window.localStorage.removeItem('returnUrl');
            case 21:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[4, 14, 17, 20]]);
      }));
      function handleRedirectWithAuth0() {
        return _handleRedirectWithAuth.apply(this, arguments);
      }
      return handleRedirectWithAuth0;
    }()
  }, {
    key: "handleRedirectWithCustomProvider",
    value: function () {
      var _handleRedirectWithCustomProvider = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.customProvider.handleRedirect();
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function handleRedirectWithCustomProvider() {
        return _handleRedirectWithCustomProvider.apply(this, arguments);
      }
      return handleRedirectWithCustomProvider;
    }()
  }, {
    key: "fetchSessionInfoUsingCustomProvider",
    value: function () {
      var _fetchSessionInfoUsingCustomProvider = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var _this4 = this;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", this.customProvider.fetchSessionInfo().then(function (session) {
                _this4.token = session.token;
                return session;
              }).finally(function () {
                _this4.setLoggedIn(_this4.token !== null);
              }));
            case 1:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function fetchSessionInfoUsingCustomProvider() {
        return _fetchSessionInfoUsingCustomProvider.apply(this, arguments);
      }
      return fetchSessionInfoUsingCustomProvider;
    }()
  }, {
    key: "fetchSessionInfoWithAuth0",
    value: function () {
      var _fetchSessionInfoWithAuth = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var _this5 = this;
        var testToken, _claims, claims;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              // Fetch from localstorage for e2e test only, real implementation
              // doesn't store real tokens in this key
              testToken = this.testTokenStorage.getItem('jwt');
              if (!testToken) {
                _context12.next = 9;
                break;
              }
              _claims = decodeJwt(testToken);
              if (!(_claims.iss === 'https://mock.taxfyle.auth0.com')) {
                _context12.next = 8;
                break;
              }
              this.token = testToken;
              runInAction(function () {
                _this5.loggedIn = true;
              });
              return _context12.abrupt("return", {
                token: testToken,
                authId: _claims.sub,
                claims: _claims
              });
            case 8:
              this.testTokenStorage.removeItem('jwt');
            case 9:
              _context12.next = 11;
              return this.auth0.getTokenSilently();
            case 11:
              this.token = _context12.sent;
              claims = decodeJwt(this.token);
              runInAction(function () {
                _this5.loggedIn = true;
              });
              return _context12.abrupt("return", {
                token: this.token,
                authId: claims.sub,
                claims: claims
              });
            case 17:
              _context12.prev = 17;
              _context12.t0 = _context12["catch"](0);
              runInAction(function () {
                _this5.loggedIn = false;
              });
              throw _context12.t0;
            case 21:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this, [[0, 17]]);
      }));
      function fetchSessionInfoWithAuth0() {
        return _fetchSessionInfoWithAuth.apply(this, arguments);
      }
      return fetchSessionInfoWithAuth0;
    }()
  }, {
    key: "setLoggedIn",
    value: function setLoggedIn(value) {
      var _this6 = this;
      runInAction(function () {
        _this6.loggedIn = value;
      });
    }
  }, {
    key: "loginWithUsernamePassword",
    value: function () {
      var _loginWithUsernamePassword = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13(opts) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return this.auth0.loginWithUsernamePassword(opts);
            case 2:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function loginWithUsernamePassword(_x7) {
        return _loginWithUsernamePassword.apply(this, arguments);
      }
      return loginWithUsernamePassword;
    }()
  }, {
    key: "saveCurrentURLToStorage",
    value: function saveCurrentURLToStorage() {
      var pathName = window.location.pathname;

      // Check for URLs we dont want to redirect user back to
      if (pathName === '/' || pathName === '/logout') {
        window.localStorage.removeItem('returnUrl');
        return;
      }
      var queryString = window.location.search;
      var url = pathName + queryString;
      window.localStorage.setItem('returnUrl', url);
    }
  }]);
}(Store), _descriptor = _applyDecoratedDescriptor(_class.prototype, "user", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "loggedIn", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "referrer", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _applyDecoratedDescriptor(_class.prototype, "useCustomProvider", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "useCustomProvider"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "login", [action], Object.getOwnPropertyDescriptor(_class.prototype, "login"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setReferrerMeta", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setReferrerMeta"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "logout", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "logout"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_setUser", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_setUser"), _class.prototype), _class);
export { AuthStore as default };
function logAuthError(err) {
  if ((err === null || err === void 0 ? void 0 : err.error) !== 'login_required') {
    console.error('Get token silently error:', err);
  }
}
function hasInviteOnlyOption(rules) {
  var _iterator = _createForOfIteratorHelper(rules),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var rule = _step.value;
      if (rule.type === 'InviteOnly') {
        return true;
      }
      if (rule.type === 'AndOr') {
        return hasInviteOnlyOption(rule.rules);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return false;
}
//# sourceMappingURL=AuthStore.js.map
